import React, { useRef } from "react";
import { get } from "lodash";
import { formatPurse } from "@tvg/formatter/currency";
import { Props } from "./types";
import { getFontFamily } from "./functions";
import PastRaceDesktop from "./Desktop";
import PastRaceMobile from "./Mobile";

const PastRace = ({
  race,
  currentRaceDistance,
  currentRaceSurface,
  isMobile = false
}: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const runner =
    race.results.runners.length > 0 ? race.results.runners[0] : null;
  const surfaceShortname = race.surface.shortName;
  const surfaceCondition = race.surface.defaultCondition;
  const distance = race.distance.value + race.distance.code.toLowerCase();
  const raceClassShortname = race.raceClass.shortName;
  const purse = formatPurse(race.purse);

  const surfaceConditionFontFamily = getFontFamily(
    surfaceCondition,
    currentRaceSurface?.defaultCondition
  );
  const surfaceShortnameFontFamily = getFontFamily(
    surfaceShortname,
    currentRaceSurface?.shortName
  );
  const distanceFontFamily = getFontFamily(distance, currentRaceDistance);

  const tooltipContent = [
    surfaceShortname,
    surfaceCondition,
    distance,
    raceClassShortname,
    purse
  ].join(" | ");
  const hasTooltip =
    (ref?.current?.scrollWidth || 0) > (ref?.current?.clientWidth || 0);

  const beatenDistance = runner?.timeform?.accBeatenDistance;
  const beatenDistanceStatus = runner?.timeform?.accBeatenDistanceStatus;
  const isVideoAvailable =
    get(race, "video.mobileAvailable", false) &&
    get(race, "video.replayFileName", false);

  const UIComponent = isMobile ? PastRaceMobile : PastRaceDesktop;

  return (
    <UIComponent
      race={race}
      runner={runner}
      isVideoAvailable={isVideoAvailable}
      tooltipContent={tooltipContent}
      hasTooltip={hasTooltip}
      surfaceShortname={surfaceShortname}
      surfaceCondition={surfaceCondition}
      distanceFontFamily={distanceFontFamily}
      distance={distance}
      currentRaceSurface={currentRaceSurface}
      raceClassShortname={raceClassShortname}
      purse={purse}
      beatenDistance={beatenDistance}
      beatenDistanceStatus={beatenDistanceStatus}
      surfaceConditionFontFamily={surfaceConditionFontFamily}
      surfaceShortnameFontFamily={surfaceShortnameFontFamily}
    />
  );
};

export default PastRace;
